"use client";

import { ThemeProvider } from "@mui/material/styles";
import DtvTheme from "@directv-digital/dds.ui.dtv-theme";
import CssBaseline from "@mui/material/CssBaseline";
import { Global, css } from '@emotion/react';
import { Gradiant_Colors } from "@/Background/BackgrondProps";
import { BrandColor } from "src/constants/CssProperties";
import { IStyleOverwriteData } from "lib/types/cache";

export function AppTheme({
  children,
  pageBackground,
  pagePath,
  styleOverwriteData
}: {
  children: React.ReactNode;
  pageBackground?: any;
  pagePath?: string;
  styleOverwriteData?: IStyleOverwriteData | null;
}) {
  const getPageBackground = () => {
    const pageContainer = pageBackground?.pageContainer;
    if (pageContainer?.color) {
      const color = pageContainer.color.toLowerCase();
      return BrandColor[color] || pageContainer.color;
    }
    if (pageContainer?.gradient && Gradiant_Colors[pageContainer.gradient]) {
      return Gradiant_Colors[pageContainer.gradient];
    }
    return pagePath?.includes("channel-lineup") ? "white" : "inherit";
  };
  const background = getPageBackground();

  // Log style overwrite data for debugging
  if (styleOverwriteData?.css) {
    console.log("## AppTheme: Style overwrite CSS applied:", {
      cssLength: styleOverwriteData.css.length,
      pagePath
    });
  }

  return (
    <ThemeProvider theme={DtvTheme}>
      <CssBaseline />
      <Global
        styles={css`
          html {
            scroll-behavior: smooth;
          }
          body {
            margin: 0;
          }
          p {
            margin: 0.5em 0em 0.5em;
          }
          /* Style Overwrite from Cache */
          ${styleOverwriteData?.css || ''}
        `}
      />

      <div
        style={{
          background
        }}
      >
        {children}
      </div>
    </ThemeProvider>
  );
}
